/* global grecaptcha, dataLayer, mbRegistrationCaptchaData, mbRegistrationGtagDataLayerData */

import 'jquery-validation';
import AddressAutocomplete from "google-address-autocomplete";
import {getStrongPasswordErrorMessage, hideButtonLoader, isStrongPassword, showButtonLoader} from "../util/helpers";

export const registration = () => {
  const options = {
    componentRestrictions: {country: "us"},
  };
  // Use a callback here to get the results
  new AddressAutocomplete("#inputStreetAddress", options, (results) => {

    const addressObject = results;

    $("input[name=address1]").val(addressObject.streetNumber + " " + addressObject.streetName);
    $("input[name=city]").val(addressObject.cityName );
    $("input[name=state]").val(addressObject.stateAbbr );
    $("input[name=sch_zipcode]").val(addressObject.zipCode );
    jQuery("#lat").val(addressObject.coordinates.lat);
    jQuery("#lng").val(addressObject.coordinates.lng);
  });

  $.validator.addMethod("autoaddress", function () {
    if ( $("#city").val().length == 0 || $("#state").val().length == 0 ) {
      return false;
    }
    return true;
  }, "Re-enter and select address from the dropdown.");

  $.validator.addMethod("fullNameNeedTwoStrings", function(value) {
    return value.split(' ').filter((word) => word.length > 0).length >= 2;
  }, "Please add both first and last names with the space between.");

  $.validator.addMethod("passwordCustomRules", function(value) {
    return isStrongPassword(value);
  }, getStrongPasswordErrorMessage);

  /**
   * matches US phone number format
   *
   * where the area code may not start with 1 and the prefix may not start with 1
   * allows '-' or ' ' as a separator and allows parens around area code
   * some people may want to put a '1' in front of their number
   *
   * 1(212)-999-2345 or
   * 212 999 2344 or
   * 212-999-0983
   *
   * but not
   * 111-123-5434
   * and not
   * 212 123 4567
   *
   * We must use copied phoneUS Jquery validation method as in the registration shortcode we are not loading additional validation plugins.
   * https://ajax.aspnetcdn.com/ajax/jquery.validate/1.11.1/additional-methods.js
   */
  jQuery.validator.addMethod("checkPhoneUS", function(phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");
    return this.optional(element) || phone_number.length > 9 &&
      phone_number.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
  }, "Please specify a valid phone number");

  $("#registrationForm").validate({
    errorElement: "span",
    ignore: ".ignore",
    rules: {
      full_name: {
        fullNameNeedTwoStrings: true,
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      address : {
        autoaddress : true,
        required: true,
      },
      password: {
        passwordCustomRules: true,
        required: true,
      },
      phone: {
        required: true,
        checkPhoneUS: true,
      },
    },
    onkeyup: false,
    onfocusout: function (element) {
      var self = this;
      if (element.name === 'address') {
        // wait for google maps response
        setTimeout(function () {
          self.element(element);
        }, 600);

      } else {
        return false;
      }
    },
    errorPlacement: function (error, element) {
      if (element.attr("name") == "user_service") {
        $(".input-like-select").addClass("error");
      }

      if ( $("#user_service").hasClass("valid") ) {
        $(".input-like-select").removeClass("error");
      }

      if (element.attr("name") == "exp_month" || element.attr("name") == "exp_year") {
        if($( "span.custom" ).length) {
          $( "span.custom" ).remove();
        }
        $(".input-like-select").addClass("error");
        error.addClass("custom");
        error.insertAfter($(".input-like-select"));
      } else {
        error.insertAfter(element);
      }
    },
    showErrors: function (errors) {
      if (errors) {
        this.defaultShowErrors();
      }
      // On this case, we need to modify css, to make it visible.
      if ($("#inputStreetAddress").hasClass("error") && 'Re-enter and select address from the dropdown.' === jQuery('#address-error').html() ) {
        $('#address-error').css('display', 'contents');
      }
    },
  });

  $(".register-button").click(function (e) {
    e.preventDefault();

    const that = $(this);
    const form = $("#registrationForm");
    const isProduction = Number(mbRegistrationGtagDataLayerData.isProduction);

    // Show loader on button click
    showButtonLoader(that);
    const formValid = form.valid();

    if (formValid) {
      const formFieldName = form.find('#inputFullName').val();
      const formFieldEmail = form.find('#inputEmail').val();

      const showCaptchaErrorMessage = () => {
        form.prepend('<h3 class="mb-5 text-center">Server validation error. <br />Please try again later.</h3>');
      }

      const generateCaptchaTokenAndSubmit = () => {
        grecaptcha.ready(() => {
          try {
              grecaptcha.execute(mbRegistrationCaptchaData.siteKey, {action: 'registration' })
                .then(function(token) {
                  document.querySelector('#recaptcha_final_step').value = token;
                })
                .then(function () {
                  if (isProduction) {
                    // Push Google tag manager data layer data - https://developers.google.com/tag-platform/tag-manager/datalayer
                    try {
                      dataLayer.push({
                        'name': formFieldName,
                        'email': formFieldEmail,
                        'event': 'register_form_submitted',
                      });
                    } catch (error) {
                      // eslint-disable-next-line no-console
                      console.info('Data layer push error.');
                    }
                  }

                  // Wait 1s just in case to add the token to the #recaptcha input
                  setTimeout(function () {
                    form.submit();
                  }, 1000);
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error) => {
                  showCaptchaErrorMessage();
                });
          } catch (error) {
            // Exception outside the promise
            showCaptchaErrorMessage();
          }
        });
      };

      generateCaptchaTokenAndSubmit();
    } else {
      hideButtonLoader(that);
    }
  });

  /**
   * Toggle password type to view password
   */
  const inputPassword = $('.mb-register__password input');
  $('.mb-register__eye').click(function () {
    if (inputPassword.attr('type') === 'text') {
      inputPassword.attr('type', 'password');
    } else {
      inputPassword.attr('type', 'text');
    }
  });

  // Populate gclid field so we know that this user has landed to registration from the Google ads
  window.addEventListener('load', function() {
    const params = (new URL(document.location)).searchParams;
    const gClid = params.get("gclid");

    if (gClid) {
      document.getElementById('mb_hidden_gclid_field_input').value = gClid;
    }
  });
};



// WEBPACK FOOTER //
// ./scripts/modules/register.js